import { useContext, useMemo } from "react"
import NotificationList from "components/Commons/Notifications/NotificationList"
import { GlobalContext } from "context/context/GlobalContext"
import SideBar from "components/Theme/Sidebar/SideBar"
import ErrorHandler from "components/Commons/Error/ErrorHandler"
import { MainContent } from "components/Theme/Layout/Main/MainLayout.styled"
import Helmet from "components/Commons/Helmet/Helmet"
import { Env, MultiClient } from "classes"

const MainLayout = (props: any) => {
  const { children } = props

  const { errorHander, notification } = useContext(GlobalContext)

  const notifications = notification?.state

  const isPrivilege = useMemo(() => {
    const [_client] = MultiClient.get_user_env(null, Env.clients, Env.env, Env.defaults)
    return _client === "privilege"
  }, [])

  if (errorHander?.state?.hasError)
    return <ErrorHandler code={errorHander.state.code} message={errorHander?.state?.message} />

  return (
    <>
      <Helmet />
      {notifications && notifications.length > 0 && <NotificationList notifications={notifications} />}
      <SideBar />
      <MainContent $isPrivilege={isPrivilege}>{children}</MainContent>
    </>
  )
}

export default MainLayout
